import axios from "axios";
import UserService from "../keycloak/UserService";

const axiosInterceptor = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosInterceptor.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token"))
      config.headers["Authorization"] = `Bearer ${localStorage.getItem(
        "token"
      )}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInterceptor.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    // If a 401 error occurs, try refreshing the token and retrying the request
    if (
      error.response?.status === 401 ||
      error.response.data.error.errorDetails === "Invalid token"
    ) {
      originalRequest._retry = true;
      try {
        // Attempt to refresh the token
        await UserService.updateToken(30);
        return axiosInterceptor(originalRequest); // Retry the request
      } catch (refreshError) {
        console.error("Token refresh failed; logging out", refreshError);
        localStorage.clear();
        UserService.doLogout({ redirectUri: window.location.origin });
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInterceptor;
